import React, { useContext } from "react";
import { useMessageSource } from "react-message-source";
import { FlexibleInvoicingModel } from "./types";
import CustomTypography from "../../../../ui/widgets/typography";
import TypographyContainer from "../../../../ui/layout/page/typography-container/typography-base-container";
import { BillingTypeOption } from "./billing-type";
import { ProductContext } from "../../../../context/product-context/productContext";
import { CentralizedBillingAltAddress } from "./centralized-billing-alt-address";

interface FlexibleInvoicingOptionProps {
  flexibleInvoicing: FlexibleInvoicingModel;
  hasDecentralizedInvoicing: boolean;
}

export const FlexibleInvoicingOption = ({
  flexibleInvoicing,
  hasDecentralizedInvoicing,
}: FlexibleInvoicingOptionProps): React.JSX.Element => {
  const { getMessage } = useMessageSource();
  const { selectedProduct } = useContext(ProductContext);

  const hasDecentralizedInvoicingFeature = selectedProduct?.hasFeature(
    "DECENTRALIZED_INVOICING",
  );

  return (
    <div className="scd-section-helper-lg">
      <TypographyContainer>
        <CustomTypography variant="h4">
          {getMessage(
            "FlexibleInvoicing.DifferentCompanyAddressOption.info.title",
          )}
        </CustomTypography>
      </TypographyContainer>
      {hasDecentralizedInvoicingFeature ? (
        <BillingTypeOption
          hasDecentralizedInvoicing={hasDecentralizedInvoicing}
        />
      ) : (
        <TypographyContainer>
          <CustomTypography variant="body2">
            {getMessage(
              "FlexibleInvoicing.DifferentCompanyAddressOption.info.text",
            )}
          </CustomTypography>
        </TypographyContainer>
      )}
      {!hasDecentralizedInvoicing && (
        <CentralizedBillingAltAddress
          dataPath={"flexibleInvoicing."}
          flexibleInvoicing={flexibleInvoicing}
        />
      )}
    </div>
  );
};
